import { Pagination, Select } from '@mui/material';
import styled from 'styled-components';

import { colorTheme } from '@styles/muiTheme';
import { DealsButton } from '@styles/StyledButtons';

export const GridColActionsWrapper = styled.div<{margin?: string}>`
&& {
    margin: ${({margin}) => margin ?? '-18px'};
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
`;

export const GridWrapper = styled.div<{ height?: string; enabled?: boolean; isFullHeightColumn?: boolean, applyPadding?: boolean, hideFooter?: boolean, isFlexible?: boolean, disablePointer?: boolean, gridBorderColor?: string, gridHighlighColor?: string}>`
  display: flex;
  flex: 1;
  height: ${({ height }) => height || '100%'};
  min-height: ${({ enabled }) => (enabled ? '100px' : 'auto')};
  border: 1px solid  ${({gridBorderColor})  =>  gridBorderColor || colorTheme.palette.grey[500]};
  margin-bottom: 10px;
  border-radius: ${({ gridBorderColor }) => gridBorderColor ? '4px' : '8px'};
  
  div.MuiDataGrid-columnHeaderTitle {
	white-space: nowrap;
  }

  .MuiTypography-h3 {
	color: ${colorTheme.palette.common.black};
  }

  .MuiDataGrid-columnHeaders {
    height: 40px;
    min-height: 0 !important;
  }

  .MuiDataGrid-cell {
    min-height: 40px !important;
  }

  ${({ gridHighlighColor }) => gridHighlighColor && `
    .MuiDataGrid-columnHeaders {
      background-color: ${gridHighlighColor};
    }

    .MuiDataGrid-columnSeparator {
    	color: ${colorTheme.palette.secondary.dark};
    }
  `}

  ${({ hideFooter }) => hideFooter && `
    div.MuiDataGrid-footerContainer {
      display: none;
    }
  `}

  ${({ isFullHeightColumn }) => isFullHeightColumn && `
    .MuiDataGrid-cell, .MuiDataGrid-row {
      max-height: none !important;
      white-space: inherit !important;
      overflow-wrap: anywhere;
    }
  `}

  ${({ isFlexible }) => isFlexible && `
    .MuiDataGrid-cell {
      word-break: break-word;
    } 

    .MuiDataGrid-cell,
    .MuiDataGrid-row,
    .MuiDataGrid-columnHeaders,
    .MuiDataGrid-columnHeaderTitle,
    .MuiDataGrid-columnHeader {
      max-height: none !important;
      white-space: normal !important;
    }
  `}

    .MuiDataGrid-row {
      cursor: ${({ disablePointer }) => disablePointer ?  'default' : 'pointer'};
    }
    .MuiDataGrid-filterIcon {
       color: ${colorTheme.palette.primary.main};
    }
`;

export const FilterPanelApplyButton = styled(DealsButton)`
	position: absolute;
	bottom: 10px;
	right: 20px;
`;

export const FilterPanelClearAllButton = styled(DealsButton)`
  position: absolute;
  bottom: 10px;
  right: 90px;
`;

export const StyledPagination = styled(Pagination) <{ paginationIconColor?: string; paginationIconBgColor?: string }>`
  & .Mui-selected {
    background-color: ${({ paginationIconBgColor }) => paginationIconBgColor || colorTheme.palette.primary.light};
    color: ${({ paginationIconColor }) => paginationIconColor || colorTheme.palette.common.white};

    &:hover {
      background-color: ${({ paginationIconBgColor }) => !paginationIconBgColor && colorTheme.palette.primary.main};
      color: ${({ paginationIconColor }) => !paginationIconColor && colorTheme.palette.common.white};
    }
  }
`;

export const StyledDropdown = styled(Select)`
  background: transparent;
  border: none;
  max-width: 185px;
  
  & .MuiSelect-select {
    border-radius: 6px;
    min-height: 50%;

    display: flex;
    align-items: center;
    justify-content: center;
    
    padding: 0px 28px 0px 0px !important; 

    svg {
      fill: ${colorTheme.palette.common.white};
    }
  }
`;